import { LOADING_REGISTER, LOADING_UNREGISTER } from './actionTypes';

export const registerLoading = () => ({ type: LOADING_REGISTER });

export const unregisterLoading = () => ({ type: LOADING_UNREGISTER });
